// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"839":"cd77fca22d867efb","901":"e2da2dd5eb0291ec"}[chunkId] + ".css";
};